/*
 * @Author: wlo_o
 * @Date: 2022-01-26 09:08:54
 * @LastEditors: wlo_o
 * @LastEditTime: 2022-02-23 11:34:32
 * @FilePath: /frontend/lib/mixins/OptionsMixin.js
 * @Description: 配置文件
 *
 * Copyright (c) 2022 by 青岛百洋智能科技股份有限公司, All Rights Reserved.
 */

import get from 'lodash/get'
import find from 'lodash/find'
export default {
  computed: {
    '$mbOptions': function () { // 全部配置
      return get(this.$OecpMetaDataConfig, 'options') || []
    },
    typeName: function () { // 类型名称
      let cfg = get(this.getMbOptionVar('typeConfig'), 'list') || []
      let type = this.type || '-1'
      let item = cfg.find(o => o.type === type)
      return item ? item.name : ''
    }
  },
  methods: {
    // 获取某一项配置
    getMbOption (optionName) {
      return find(get(this.$OecpMetaDataConfig, 'options') || [], item => item.optionName === optionName)
    },
    getMbOptionVar (extName) {
      let item = this.getMbOption(extName)
      // console.log('option:', item)
      let obj = null
      // eslint-disable-next-line no-eval
      if (item) { try { obj = eval('(' + item.optionValue + ')') } catch (error) { console.error(error) } }
      return obj
    }
  }
}
